import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { analyticsService } from '../services/analyticsService';

const PageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page visit when component mounts or location changes
    const trackVisit = async () => {
      const pagePath = location.pathname;
      
      // Skip tracking admin panel visits
      if (pagePath === '/admin') {
        return;
      }
      
      const pageTitle = document.title || getPageTitleFromPath(pagePath);
      
      await analyticsService.trackPageVisit(pagePath, pageTitle);
    };

    trackVisit();
  }, [location.pathname]);

  // Helper function to get page title from path
  const getPageTitleFromPath = (path) => {
    const titleMap = {
      '/': 'Home',
      '/about': 'About Us',
      '/contact': 'Contact',
      '/upload': 'Upload Article',
      '/tracking': 'Article Tracking',

      '/privacy-policy': 'Privacy Policy',
      '/copyright': 'Copyright',
      '/tech-team': 'Tech Team',
      '/terms-of-service': 'Terms of Service',
      '/disclaimer': 'Disclaimer',
      '/call-articles': 'Call for Articles',
      '/types-of-articles': 'Types of Articles',
      '/information-for-authors': 'Information for Authors',
      '/submission-guidelines': 'Submission Guidelines',
      '/article-processing-charge': 'Article Processing Charge (APC)'
    };

    return titleMap[path] || 'Page';
  };

  // This component doesn't render anything
  return null;
};

export default PageTracker; 